(function(){
  'use strict';
  if(window.__cwCartIcon) return; window.__cwCartIcon=true;
  function onClick(e){
    var t=e.target;
    var a=(t&&t.closest)?t.closest('a.header__icon[href], a.header__cart[href], a[href].js-cart-link'):null;
    if(!a) return;
    var href=(a.getAttribute('href')||'').split('?')[0];
    if(href.slice(-5)!=='/cart') return;
    var drawer=document.querySelector('cart-drawer');
    if(!drawer) return;
    if(drawer.isDocked) return;
    e.preventDefault();
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open',{detail:{opener:a}}));
  }
  document.addEventListener('click', onClick, true);
})();
